import { HomeScreenThemeModeConfig } from './types';

const light: HomeScreenThemeModeConfig = {
  homeScreen: {
    backgroundColor: '#ffffff', // Light background color
    backgroundGradient: 'linear-gradient(to top,rgb(206, 206, 206), #ffffff)', // Gradient for background
    textColor: '#333333', // Dark text color for contrast
    borderColor: '#cccccc', // Light border color
    hoverBackgroundColor: '#e0e0e0', // Background color on hover
    hoverTextColor: '#000000', // Text color on hover
  },
};

export default light;
